import feathersClient from "../../feathers-client";

const defaultEndorsementRequestPagination = {
	total:100,
	$skip:0,
	$limit:6,
};
const defaultEndorsementRequestPaginationFilter = {
	$skip:defaultEndorsementRequestPagination.$skip,
	$limit: defaultEndorsementRequestPagination.$limit
};
export default {
	state:{
		endorsementRequest:[],
		endorsementRequestPagination:defaultEndorsementRequestPagination,
		endorsementRequestPaginationFilter:defaultEndorsementRequestPaginationFilter
	},
	getters:{
		setEndorsementRequestPage:(state) => {
			const {$limit, $skip} = state.endorsementRequestPagination;
			return $skip / $limit + 1;
		},
	},
	mutations:{
		SET_ENDORSEMENT_REQUEST:(state,data) => {state.endorsementRequest = data;},
		SET_ENDORSEMENT_REQUEST_PAGINATION:(state, data) => {state.endorsementRequestPagination = {...state.endorsementRequestPagination, ...data};},
		SET_ENDORSEMENT_REQUEST_PAGINATION_FILTER:(state,data) => {state.endorsementRequestPaginationFilter  = {...state.endorsementRequestPaginationFilter, ...data};}
	},
	actions:{
		setendorsementRequestListPage:({commit,state},page) =>{
			const $skip = (page - 1) * state.endorsementRequestPagination.$limit;
			commit('SET_ENDORSEMENT_REQUEST_PAGINATION', { $skip });
			commit('SET_ENDORSEMENT_REQUEST_PAGINATION_FILTER', { $skip });
		},

		getEndorsementRequest: async({rootGetters,commit},filter) => {
			const results = await feathersClient.service('/api/v3/endorsement-requests').find({
				query:{
					$role: rootGetters.currentUserRole,
					fields: ['bands','jobTitle'],
					...filter
				}
			});
			commit('SET_ENDORSEMENT_REQUEST',results.data);
			commit('SET_ENDORSEMENT_REQUEST_PAGINATION', {total :results.total})
			return results.data;
		},
		createEndorsementRequest: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/endorsement-requests').create(data,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return results;
		},
		updateEndorsementRequest: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/endorsement-requests').patch(data.id, data,{
				query:{
					$role: rootGetters.currentUserRole,
					$approved:true
				}
			});
			return results;
		},
		deleteEndorsementRequest: async ({rootGetters},id) => {
			const results = await feathersClient.service('/api/v3/endorsement-requests').remove(id,{
				query:{
					$role:rootGetters.currentUserRole,
				}
			});
			return results;
		},
		getEndorsementRequestById: async({rootGetters},id) =>{
			const results = await feathersClient.service('/api/v3/endorsement-requests').get(id,{
				query:{
					$role: rootGetters.currentUserRole,
					fields:['endorsementItems','endorsementRequestUsers'],
				}
			});

			return results
		},
		getAllEndorsementRequestForTrust: async({rootGetters,commit},filter) => {
			let sortField = 'createdAt';
			if (filter.status && filter.status.includes('APPROVED')) {
				sortField = 'approvedAt';
			}
			const results = await feathersClient.service('/api/v3/endorsement-requests').find({
				query: {
					$role: rootGetters.currentUserRole,
					$facilitator: true,
					$sort: { [sortField]: -1 },
					// fields:['endorsementRequestSkills','endorsementRequestUsers'],
					fields: ['endorsementItems', 'endorsementRequestUsers'],
					...filter,

				},
			});
			commit('SET_ENDORSEMENT_REQUEST', results.data);
			commit('SET_ENDORSEMENT_REQUEST_PAGINATION', { total: results.total})
			return results.data;
		},
		getAllEndorsementRequest: async({rootGetters}) => {
			const results = await feathersClient.service('/api/v3/endorsement-requests').find({
				query:{
					$role:rootGetters.currentUserRole,
				}
			});
			return results.data;
		},

	}
}
